import { Card, Image, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";

import { Button } from "../../../components/Button";
import { type PlacementCandidate } from "../../../PlacementCandidate/types";
import { useRecruiterBookingFlowContext } from "../../hooks/useRecruiterBookingFlowContext";
import { useTalkToRecruiterCopyText } from "../../hooks/useTalkToRecruiterCopyText";
import { RecruiterScreeningCallDialog } from "./RecruiterScreeningCallDialog";

export function RecruiterScreeningCallCard({
  placementCandidate,
}: {
  placementCandidate: PlacementCandidate;
}) {
  const {
    screeningConfig: { screeningCalendlyLink, showCallMeNow },
    modalState,
  } = useRecruiterBookingFlowContext();
  const { banner, id } = useTalkToRecruiterCopyText();
  return (
    <>
      <Card
        sx={{
          p: 1.5,
          background: `linear-gradient(135deg, #FBF2E8 20%, #B7DDFF 100%)`,
        }}
      >
        <CardContent component={Stack} spacing={5} sx={{ alignItems: "center" }}>
          <Stack
            spacing={3}
            flexDirection="row"
            sx={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <Stack spacing={6} sx={{ mr: "-44px !important" }}>
              <Text semibold variant="h6">
                {banner.screening}
              </Text>
              <Button
                variant="outlined"
                sx={{ border: "none", width: "fit-content" }}
                onClick={async () => {
                  // log event
                  logEvent(APP_V2_APP_EVENTS.PLACEMENT_CARD_TALK_TO_RECRUITER_CLICKED, {
                    placementCandidate,
                    copyId: id,
                  });

                  if (showCallMeNow) {
                    modalState.openModal();
                    logEvent(APP_V2_APP_EVENTS.PLACEMENT_RECRUITER_SCREENING_CALL_MODAL_OPENED, {
                      placementCandidateId: placementCandidate.id,
                      showCallMeNow,
                      copyId: id,
                      source: "banner",
                    });
                  } else {
                    await openInBrowser({ url: screeningCalendlyLink });
                  }
                }}
              >
                {banner.screeningAction}
              </Button>
            </Stack>

            <Image src="assets/images/3d-phone.png" alt="Clipboard" width="40%" />
          </Stack>
        </CardContent>
      </Card>
      {showCallMeNow && (
        <RecruiterScreeningCallDialog
          modalState={modalState}
          source="banner"
          placementCandidate={placementCandidate}
        />
      )}
    </>
  );
}
